import { z } from 'zod'
import { emailSchema } from '../validators/email.validator.js'
import { linkTokenParamSchema } from '../validators/params.js'

/** A new tenant-user password. Length is the only rule; argon2 does the rest. */
export const newPasswordSchema = z
  .string()
  .min(12, 'Use at least 12 characters')
  .max(128, 'Use at most 128 characters')

export const tenantLoginInputSchema = z
  .object({
    email: emailSchema,
    password: z.string().min(1, 'Password is required').max(128),
  })
  .strict()

export type TenantLoginInput = z.infer<typeof tenantLoginInputSchema>

/**
 * Accepting an invitation. An existing account proves itself with its current
 * password; a new account needs a name and sets its password here.
 */
export const acceptInvitationInputSchema = z
  .object({
    password: z.string().min(1, 'Password is required').max(128),
    name: z.string().trim().min(1).max(200).optional(),
  })
  .strict()

export type AcceptInvitationInput = z.infer<typeof acceptInvitationInputSchema>

export const passwordResetRequestInputSchema = z
  .object({ email: emailSchema })
  .strict()

export type PasswordResetRequestInput = z.infer<typeof passwordResetRequestInputSchema>

export const passwordResetConfirmInputSchema = z
  .object({
    token: linkTokenParamSchema,
    password: newPasswordSchema,
  })
  .strict()

export type PasswordResetConfirmInput = z.infer<typeof passwordResetConfirmInputSchema>
